import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormArray,
  FormGroup,
  FormBuilder,
  FormControl
} from "@angular/forms";
import {AlertService, AuthenticationService} from '@app/_services';
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import {User} from '@app/_models';
import {Subscription} from 'rxjs';
import {ProformaService} from '@app/_components/proforma/proforma.service';
import { PropertyService } from "..";
import { PropertyLeadProfileService } from "@app/_components/property-lead-profile/property-lead-profile.service";

@Component({
    selector: "app-property-mls",
    templateUrl: "./property-mls.component.html",
    styleUrls: ["./property-mls.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})

export class PropertyMlsComponent implements OnInit {
  currentUser: User;
  currentUserSubscription: Subscription;
  constructor(
    private primengConfig: PrimeNGConfig,
    private alertService: AlertService,
    private propertyLeadProfileService: PropertyLeadProfileService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private authenticationService: AuthenticationService,
    private _formBuilder: FormBuilder,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
   
    this.formTitle = data.title,
      this.subjAdrStreet = data.addressStreetName,
      this.subjAdrUnit = data.addressUnit,
      this.subjAdrCity = data.addressCity;
      this.subjAdrState = data.addressState;
      this.subjAdrPostalCode = data.addressZip;
      
      this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
          this.currentUser = user;
      });
  }

  
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();


  // data
  subjAdrStreet: any;
  subjAdrUnit: any;
  subjAdrCity: any;
  subjAdrState: any;
  subjAdrPostalCode: any;
  // for
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  validationMessages = {
    mlsAllId: [],
    subjAdrStreet: [{ type: 'required', message: 'Required' }],
    subjAdrUnit: [{ type: 'required', message: 'Required' }],
    subjAdrCity: [{ type: 'required', message: 'Required' }],
    subjAdrState: [{ type: 'required', message: 'Required' }],
    subjAdrPostalCode: [{ type: 'required', message: 'Required' }],
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.formBuild();
    this.form1.patchValue({
      subjAdrStreet : this.subjAdrStreet,
      subjAdrUnit : this.subjAdrUnit,
      subjAdrCity : this.subjAdrCity,
      subjAdrState : this.subjAdrState,
      subjAdrPostalCode : this.subjAdrPostalCode,
      realtorProfileId: this.currentUser.userId
    });
  }

  requestProforma() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      
      this.formLoading = true;
      this.propertyLeadProfileService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-request SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.doAdd.emit(res);
        },
        (err: any) => {
          console.log("property-request FAIL: " + JSON.stringify(err));
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
          this.alertService.error(err);
          this.formLoading = false;
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      subjAdrStreet: ['', Validators.required],
      subjAdrUnit: ['', Validators.required],
      subjAdrCity: ['', Validators.required],
      subjAdrState: ['', Validators.required],
      subjAdrPostalCode: ['', Validators.required],
    });
  }
}
